<template>
  <div>
    <h2 class="p-txt-title--border">
      <i :class="labels[targetLabel].font_class" />
      {{ labels[targetLabel].text }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'EventSectionHeading',
  props: {
    targetLabel: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      labels: {
        relational: {
          text: '関連イベント',
          font_class: 'fas fa-chalkboard-teacher'
        },
        recommend: {
          text: 'オススメ',
          font_class: 'far fa-thumbs-up'
        },
        personal_development: {
          text: '個人アプリ開発',
          font_class: 'far fa-file-code'
        },
        dev_tool: {
          text: '開発ツール',
          font_class: 'fas fa-tools'
        },
        lt: {
          text: 'LT大会',
          font_class: 'fas fa-microphone'
        },
        web_frontend: {
          text: 'Webフロントエンド',
          font_class: 'fas fa-laptop-code'
        }
      }
    }
  }
}
</script>
